import React, { useEffect, useMemo, useState } from "react";

export default function SearchableSelect({
  items = [],
  getId = (x) => x?.id ?? x?.Id,
  getLabel = (x) => x?.name ?? x?.Name,
  value,
  onChange,
  placeholder = "Search...",
}) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    // Ensure value is valid; if not provided and list has items, keep as-is
  }, [items, value]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((it) => String(getLabel(it) ?? "").toLowerCase().includes(q));
  }, [items, query, getLabel]);

  return (
    <div className="st-select-search">
      <input
        className="st-input st-search"
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <select
        className="st-select"
        value={value ?? ""}
        onChange={(e) => onChange && onChange(e.target.value)}
      >
        {filtered.length === 0 ? (
          <option value="" disabled>
            No results
          </option>
        ) : (
          filtered.map((it) => {
            const id = String(getId(it));
            const label = String(getLabel(it) ?? id);
            return (
              <option key={id} value={id}>
                {label}
              </option>
            );
          })
        )}
      </select>
    </div>
  );
}
